import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import settingsStore from './settings';
import performanceStore from './performance';
import IntervalService from './../services/intervals';
import sessionStore from './session';
import { subscribeWithSelector } from 'zustand/middleware';
import muvikaAttrs from './../attrs'

const minTime = 30;

const initialState = {
  isSet: false,
  isExternalWaiting: false,
  isPlaying: { isPlaying: false },
  isStopped: { isStopped: true },
  isBuffering: { isBuffering: false },
  currentTrack: null,
  currentTime: 0,
  isReady: true,
  isSeeking: false,
  isFocused: true,
  from: { from: 0 },
  currentPerformanceId: null,
  isFullScreen: false,
  currentPitch: 0,
  pitchRecog:{currentPitch: 0},
  isPitchEditable: true,
  currentVolume: {currentVolume: 0, doNotPropagate: false},
  currentBuffer: 0,
  isInIosExternalScreen: false,
  isInAndroidExternalScreen: false,
  isInExternalWindow: false,
  isInBasicScreen: false,
  currentVersion: "normal",
  streamUrl: "",
  previewStreamUrl: "",
  previewCurrentTime: 0,
  isAutoPlayOn: false,
  isTrackLogSent: null,
  mockTimer: null,
  isSwitching: false,
  isSmallVideo: false,
  isCastAvailable: false,
  isRequestingCasting: false,
  isCasting: false,
  isExternalWindowAvailable: false,
  iosExternalScreenWidth: 0,
  externalWindowHandle: null,
  isWaitingCasting: false,
  iosFrom: null,
  iosPlayPauseHackOn:false,
  hasBeenPlayed: false
};

const playerStore = create(subscribeWithSelector((set, get) => (
  {
    ...initialState,
    reset: () => {
      set(initialState);
    },
    setHasBeenPlayed: (hasBeenPlayed) => {
      set({ hasBeenPlayed: hasBeenPlayed })
    },
    setIosPlayPauseHackOn: (iosPlayPauseHackOn) => {
      set({ iosPlayPauseHackOn: iosPlayPauseHackOn })
    },
    setIsReady: (isReady) => {
      console.log("isReady", isReady)
      set({ isReady: isReady });
    },
    softReset: () => {
      set({
        isSet: false,
        isReady: true,
        isExternalWaiting: false,
        isPlaying: { isPlaying: false },
        isStopped: { isStopped: true, isSoftStop: true },
        isBuffering: { isBuffering: false },
        currentTrack: null,
        currentTime: 0,
        from: { from: 0 },
        currentPerformanceId: null,
        currentPitch: 0,
        pitchRecog:{currentPitch: 0},
        isPitchEditable: true,
        currentBuffer: 0,
        currentVersion: settingsStore.getState().settings ? (settingsStore.getState().settings?.voc_enabled ? "vocal" : "normal") : "normal",
        streamUrl: "",
        previewStreamUrl: "",
        previewCurrentTime: 0,
        isWaitingCasting: false,
        isSeeking: false,
        iosFrom: null,
      });
    },
    setIsWaitingCasting: (isWaiting) => {
      set({ isWaitingCasting: isWaiting });
    },
    setIsRequestingCasting: (isRequestingCasting) => {
      set({ isRequestingCasting: isRequestingCasting });
    },
    setIsCasting: (isCasting) => {
      set({ isCasting: isCasting });
    },
    setIsExternalWaiting: (isWaiting) => {
      set({ isExternalWaiting: isWaiting });
    },
    setCastAvailable: (isAvailable) => {
      set({ isCastAvailable: isAvailable });
    },
    setExternalWindowAvailable: (isAvailable) => {
      set({ isExternalWindowAvailable: isAvailable });
    },
    setBasicScreen: (isInBasicScreen) => {
      set({ isInBasicScreen: isInBasicScreen });
    },
    setCurrentBuffer: (buffer) => {
      set({ currentBuffer: buffer });
    },
    setIsSmallVideo: (isSmallVideo) => {
      set({ isSmallVideo: isSmallVideo });
    },
    setIsPitchEditable: (isPitchEditable) => {
      set({ isPitchEditable: isPitchEditable });
    },
    setIsSwitching: (isSwitching) => {
      console.log("isReady isSwitching", isSwitching)
      set({ isSwitching: isSwitching });
    },
    setIsTrackLogSent: (id) => {
      set({ isTrackLogSent: id });
    },
    setIsAutoPlayOn: (isAutoPlayOn) => {
      set({ isAutoPlayOn: { isAutoPlayOn: isAutoPlayOn } });
    },
    empty: () => {
      set({ isSet: false, isPlaying: { isPlaying: false }, isStopped: { isStopped: true }, currentTrack: null, streamUrl: "", currentTime: 0, currentVersion: settingsStore.getState().settings ? (settingsStore.getState().settings?.voc_enabled ? "vocal" : "normal") : "normal", currentPitch: 0, pitchRecog:{currentPitch: 0 }, iosFrom: null});
    },
    trackEnded: (sessionToken, profileId) => {
      if (get().currentTrack) {
        if (get().currentTime >= minTime) {
          //console.log(get().currentTrack + " " + get().currentPitch + " " + profileId);
          MuvikaService.setTrackLog(sessionToken, get().currentTrack, get().currentPitch, profileId)
            .then(function (res) {
              if (res.data.error) {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            })
            .catch(function () { });
        }
      }
    },
    getStreamUrl: (sessionToken, currentPerformance, track, pitch = 0, version = "normal", from = 0, play = false, isInPreviewMode = false) => {
      set({ from: 0, isPitchEditable: false });
      if (track.flags) {
        if (track.flags.includes("voc_avail")) {
          if (version === "vocal") {
            pitch = 0;
          }
        } else {
          if (version === "vocal") {
            version = "normal";
          }
        }
      }else{
        version="normal";
      }
      console.log("test get stream url", pitch, version, from)
      MuvikaService.getStreamUrl(sessionToken, track.track_id, pitch, version, true)
        .then(function (res) {
          //console.log(res);
          if (res.data.error) {
            set({ isSet: false, currentPerformanceId: currentPerformance.unique_id, isPlaying: { isPlaying: false }, currentTime: from, currentTrack: track, streamUrl: "" });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            set({ isSet: true, currentPerformanceId: currentPerformance.unique_id, previewStreamUrl: res.data.data.preview_url, isPlaying: { isPlaying: play }, currentTime: from, iosFrom: { from: from }, currentTrack: track, streamUrl: res.data.data.url });
          }
        })
        .catch(function () { 
          IntervalService.clearAllIntervals();
          set({ isSet: false, isPlaying: { isPlaying: false }, isStopped: { isStopped: true }, streamUrl: "", previewStreamUrl: "", currentTime: 0 }); 
        });
    },
    getPreviewStreamUrl: (sessionToken, trackId, from = 0, play = false) => {
      MuvikaService.getStreamUrl(sessionToken, trackId, 99, "preview")
        .then(function (res) {
          //console.log(res);
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            set({ previewStreamUrl: res.data.data.url, isPlaying: { isPlaying: play }, currentTime: from });
          }
        })
        .catch(function () { console.log("catch"); set({ isSet: false, isPlaying: { isPlaying: false }, isStopped: { isStopped: true }, previewStreamUrl: "", currentTime: 0 }); });
    },
    setCurrentVersion: (version) => {
      let newSettings = { ...settingsStore.getState().settings };
      if (version === "vocal") {
        newSettings.voc_enabled = 1;
      } else if (version === "normal") {
        newSettings.voc_enabled = 0;
      }
      settingsStore.getState().setSettings(sessionStore.getState().sessionToken, newSettings);
      set({ currentVersion: version });
    },
    setCurrentPitch: (pitch) => {
      console.log("test get stream url t", pitch);
      set({ currentPitch: pitch, pitchRecog:{currentPitch: pitch}, isPitchEditable: true });
    },
    setCurrentTime: (time) => {
      set({ currentTime: time });
    },
    setPreviewCurrentTime: (time) => {
      set({ previewCurrentTime: time });
    },
    setCurrentTrack: (track) => {
      set({ currentTrack: track });
    },
    setFullScreen: (isFullScreen) => {
      set({ isFullScreen: isFullScreen });
    },
    setIsPlaying: (isPlaying) => {
      console.log("setting isPlaying in store", isPlaying)
      set({ isPlaying: { isPlaying: isPlaying } });
    },
    setIsBuffering: (isBuffering) => {
      set({ isBuffering: { isBuffering: isBuffering } });
    },
    setIsInExternalWindow: (isInExternalWindow) => {
      set({ isInExternalWindow: isInExternalWindow });
    },
    setIsInIosExternalScreen: (isInIosExternalScreen) => {
      set({ isInIosExternalScreen: isInIosExternalScreen });
    },
    setIsInAndroidExternalScreen: (isInAndroidExternalScreen) => {
      set({ isInAndroidExternalScreen: isInAndroidExternalScreen });
    },
    setIosFrom: (from) => {
      //console.log(from);
      set({ iosFrom: { from: from } });
    },
    setFrom: (from) => {
      //console.log(from);
      set({ from: { from: from } });
    },
    setVolume: (volume, doNotPropagate=false) => {
      console.log("setVolume", volume)
      set({ currentVolume: { currentVolume: volume, doNotPropagate: doNotPropagate} });
    },
    setSeeking: (isSeeking) => {
      set({ isSeeking: isSeeking });
    },
    setIsFocused: (isFocused) => {
      set({ isFocused: isFocused });
    },
    setIsStopped: (isStopped, isSoftStop) => {
      set({ isStopped: { isStopped: isStopped, isSoftStop: isSoftStop } });
    }
  }),
  {
    name: muvikaAttrs.service+'-player-storage',
    storage: createJSONStorage(() => sessionStorage),
  }
));

export default playerStore;